module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "fade",
    staticClass: "custom-new-patients-iframe"
  }, [_c('div', {
    staticClass: "custom-new-patients__wrap"
  }, [_c('iframe', {
    staticClass: "custom-new-patients__iframe",
    attrs: {
      "width": "560",
      "height": "315",
      "src": _vm.props.iframe,
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "allowfullscreen": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ceaf0e6c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-new-patients-iframe/custom-new-patients-iframe.pug
// module id = 670
// module chunks = 1